import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as BagIcon } from "assets/svgs/header-bag.svg";
import { ReactComponent as BagIconMobile } from "assets/svgs/header-bag-mobile.svg";
import { OPEN_CART, TOGGLE_SUBS_CART } from "utils/action-types";
import navigate from "helpers/navigate";
import { isMobile } from "utils/device-detect";

const HeaderBag = () => {
	const dispatch = useDispatch();
	const { activeBox, totalProgress } = useSelector((state) => state.cart);
	const { isActive, subscriptionId, totalWeight } = useSelector((state) => state.account.subscription);
	const isMobileView = isMobile();

	const handleClick = () => {
		let path = "/box";

		if (isActive) {
			path = "/account/subscription/manage-products";
			if (!isMobileView) {
				setTimeout(() => dispatch({ type: TOGGLE_SUBS_CART }), 100);
			}
		} else if (subscriptionId) {
			path = "/account/subscription";
		} else if (totalProgress > 0) {
			path = "/collections/all-products";

			if (totalProgress >= activeBox?.size?.value && !isMobileView) {
				setTimeout(() => {
					dispatch({ type: OPEN_CART });
				}, 1000);
			}
		}

		navigate(path);
	};

	const total = subscriptionId ? totalWeight : totalProgress;

	return (
		<button onClick={handleClick} className="relative">
			<span
				className="header-icon !justify-end pt-2">
				<BagIconMobile className="md:hidden" /><BagIcon className="hidden md:block" />
			</span>
			{total > 0 &&
				<div
					className="bg-orange rounded-full absolute text-smaller lg:text-small top-1 text-white py-0 px-2 right-1.5"
				>
					{total}
				</div>}
		</button>
	);
};

export default HeaderBag;
